import { ChangeDetectionStrategy, Component } from '@angular/core';
import { EntityTypes } from 'src/app/common-models/node-types/node-types';

@Component({
  selector: 'app-project-curve',
  templateUrl: './project-curve.component.html',
  styleUrls: ['./project-curve.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectCurveComponent {
  entityType = EntityTypes.project;
}
